function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1",
  "data-name": "Rectangle 1",
  width: 419,
  height: 335,
  transform: "translate(665 -5)",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 469.844,
  height: 466.32,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_1",
  "data-name": "Mask Group 1",
  transform: "translate(-665 5)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Repeat_Grid_1",
  "data-name": "Repeat Grid 1",
  transform: "translate(639.256 -211.313)",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-639.256 211.313)"
}, /*#__PURE__*/React.createElement("path", {
  id: "open",
  d: "M-30.156-132.112-65.686-91.24l239.7,208.368h0l32.668,28.4h0l41.754,36.3,35.53-40.872Z",
  transform: "translate(775.503 74.692) rotate(-41)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "open-2",
  "data-name": "open",
  d: "M-30.156-132.112-65.686-91.24l239.7,208.368h0l32.668,28.4h0l41.754,36.3,35.53-40.872Z",
  transform: "translate(775.503 214.692) rotate(-41)"
}), /*#__PURE__*/React.createElement("path", {
  id: "open-3",
  "data-name": "open",
  d: "M-30.156-132.112-65.686-91.24l239.7,208.368h0l32.668,28.4h0l41.754,36.3,35.53-40.872Z",
  transform: "translate(775.503 354.692) rotate(-41)"
})));

var SvgHamburger = function SvgHamburger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 335,
    viewBox: "0 0 419 335",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHamburger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hamburger.69911c67.svg";
export { ForwardRef as ReactComponent };